function RenderComponent({
  isShow,
  children,
}: {
  isShow: boolean
  children: JSX.Element | JSX.Element[]
}): JSX.Element {
  if (isShow) return <>{children}</>
  return null
}

export default RenderComponent
